import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from '@src/store'
import { useMediaQuery, useTheme } from '@mui/material'

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()


export function useIsTablet() {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('md'))
}

export function useIsMobile() {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('sm'))
}